import {
  getAddressFieldsConfig,
  propertyMortgageConfigFields,
} from 'app/pages/loanApplication/LoanApplication.sharedConfigs';
import { closingCompanyEditConfigFields } from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/ClosingCompanyForm/ClosingCompanyForm.config';
import { fundingInformationEditConfigFields } from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/FundingInformation/FundingInformationEditor.config';
import {
  titleHolderEditConfigFields,
  titleHolderPropertyRelatedInfoEditConfigFields,
  trustInfoEditConfigFields,
} from 'app/pages/loanApplication/tabs/loanClosingCDS/shared/TitleHolderInfo/TitleHolderInfoEdit.config';
import { loanFeeCicFormFields as loanFeeCicTabEditConfigFields } from 'app/pages/loanApplication/tabs/loanFees/components/LoanFeeCicForm/LoanFeeCicForm.config';
import { investorEditConfigFields } from 'app/pages/loanApplication/tabs/postClosing/PostClosing.config';
import { additionalFinancingConfigFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/AdditionalFinancing/AdditionalMortgageForm/AdditionalMortgageForm.config';
import { creditFields as creditsConfigFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/Credits/Credits.config';
import { loanInfoConfigFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/LoanInfo/LoanInfo.config';
import { propertyConfigFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/Property/Property.config';
import { proposedPropertyExpensesFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/PropertyExpenses/PropertyExpenses.config';
import { transactionDetailsConfigFields } from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/TransactionDetails/TransactionDetails.config';
import { documentExpirationDatesLoanChangesConfig } from 'app/pages/loanApplication/tabs/underwritingCDS/DocumentExpirationDates/DocumentExpirationDateForm/DocumentExpirationDateForm.config';
import { programConfigFields as programTabEditConfigFields } from 'app/pages/programs/programs/ProgramForm.config';

import { LoanChangesHistoryEntityType } from 'constants/loanChanges';

import { loanFeesFormFields } from './deprecatedConfig/LoanFeesForm.config';
import { excludedOnUiFieldsConfig } from './excludedOnUiFields.config';
import {
  addressConfigFields,
  assetConfigFields,
  declarationConfigFields,
  incomeConfigFields,
  liabilitiesConfigFields,
  linkedToEntityBorrowerIdFieldConfig,
  personalInfoConfigFields,
  raceAndEthnicityHistoryConfigFields,
  reoConfigFields,
} from './LoanChangesHistoryFields.constants';

const defaultAddressConfigFields = getAddressFieldsConfig({ prefix: null });

export const LoanChangesHistoryFieldsConfig = {
  [LoanChangesHistoryEntityType.LOAN]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.LOAN],
    ...loanInfoConfigFields,
    ...transactionDetailsConfigFields,
    ...programTabEditConfigFields,
    pmiManualUpdate: proposedPropertyExpensesFields.pmiManualUpdate,
  },
  [LoanChangesHistoryEntityType.APPLICATION]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.APPLICATION],
    ...creditsConfigFields,
    ...titleHolderPropertyRelatedInfoEditConfigFields,
    ...loanInfoConfigFields,
    leadSourceId: loanInfoConfigFields.leadSource,
  },
  [LoanChangesHistoryEntityType.BORROWER]: {
    ...raceAndEthnicityHistoryConfigFields,
    ...personalInfoConfigFields,
    ...declarationConfigFields,
  },
  [LoanChangesHistoryEntityType.NON_BORROWER_ENTITY]: {
    dateOfBirth: personalInfoConfigFields.dateOfBirth,
  },
  [LoanChangesHistoryEntityType.RESIDENCE]: addressConfigFields,
  [LoanChangesHistoryEntityType.ADDRESS]: defaultAddressConfigFields,
  [LoanChangesHistoryEntityType.PROPERTY]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.PROPERTY],
    ...propertyConfigFields,
    ...reoConfigFields,
    firstMortgageId: propertyMortgageConfigFields.liabilityId,
    secondMortgageId: propertyMortgageConfigFields.liabilityId,
  },
  [LoanChangesHistoryEntityType.TITLE_HOLDER]: titleHolderEditConfigFields,
  [LoanChangesHistoryEntityType.INCOME]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.INCOME],
    ...incomeConfigFields,
  },
  [LoanChangesHistoryEntityType.ASSET]: assetConfigFields,
  [LoanChangesHistoryEntityType.LIABILITY]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.LIABILITY],
    ...liabilitiesConfigFields,
  },
  [LoanChangesHistoryEntityType.BORROWER_ASSET]: linkedToEntityBorrowerIdFieldConfig,
  [LoanChangesHistoryEntityType.BORROWER_LIABILITY]: linkedToEntityBorrowerIdFieldConfig,
  [LoanChangesHistoryEntityType.BORROWER_PROPERTY]: linkedToEntityBorrowerIdFieldConfig,
  [LoanChangesHistoryEntityType.LOAN_FEE]: loanFeesFormFields,
  [LoanChangesHistoryEntityType.LOAN_FEE_HISTORY]:
    excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.LOAN_FEE_HISTORY],
  [LoanChangesHistoryEntityType.LOAN_CIC_FEE_REASON]: loanFeeCicTabEditConfigFields,
  [LoanChangesHistoryEntityType.CLOSING_COMPANY]: closingCompanyEditConfigFields,
  [LoanChangesHistoryEntityType.TRUST]: trustInfoEditConfigFields,
  [LoanChangesHistoryEntityType.LOAN_FUNDING]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.LOAN_FUNDING],
    ...fundingInformationEditConfigFields,
  },
  [LoanChangesHistoryEntityType.LOAN_CLOSING_INVESTOR]: {
    ...excludedOnUiFieldsConfig[LoanChangesHistoryEntityType.LOAN_CLOSING_INVESTOR],
    ...investorEditConfigFields,
  },
  [LoanChangesHistoryEntityType.APPLICATION_ADDITIONAL_MORTGAGE]: additionalFinancingConfigFields,
  [LoanChangesHistoryEntityType.DOCUMENT_EXPIRATION_DATE]: documentExpirationDatesLoanChangesConfig,
};
